/**
 * Permisos alineados al backend (rbac.middleware)
 */

export type Permission =
  | 'topology:read'
  | 'topology:write'
  | 'import:execute'
  | 'export:execute'
  | 'user:list'
  | 'user:create'
  | 'user:update'
  | 'user:delete'
  | 'user:invite'
  | 'tenant:read'
  | 'tenant:update'
  | 'billing:read'
  | 'billing:manage'

export type AppUserRole =
  | 'SUPER_ADMIN'
  | 'TENANT_ADMIN'
  | 'DESIGNER'
  | 'TECHNICIAN'
  | 'VIEWER'
  | 'ADMIN'
  | 'EDITOR'

function normalizeRole(role: string): AppUserRole {
  if (role === 'ADMIN') return 'TENANT_ADMIN'
  if (role === 'EDITOR') return 'DESIGNER'
  return role as AppUserRole
}

const MATRIX: Record<Permission, AppUserRole[]> = {
  'topology:read': ['SUPER_ADMIN', 'TENANT_ADMIN', 'DESIGNER', 'TECHNICIAN', 'VIEWER'],
  'topology:write': ['SUPER_ADMIN', 'TENANT_ADMIN', 'DESIGNER'],
  'import:execute': ['SUPER_ADMIN', 'TENANT_ADMIN', 'DESIGNER'],
  'export:execute': ['SUPER_ADMIN', 'TENANT_ADMIN', 'DESIGNER'],
  'user:list': ['SUPER_ADMIN', 'TENANT_ADMIN'],
  'user:create': ['SUPER_ADMIN', 'TENANT_ADMIN'],
  'user:update': ['SUPER_ADMIN', 'TENANT_ADMIN'],
  'user:delete': ['SUPER_ADMIN', 'TENANT_ADMIN'],
  'user:invite': ['SUPER_ADMIN', 'TENANT_ADMIN'],
  'tenant:read': ['SUPER_ADMIN', 'TENANT_ADMIN'],
  'tenant:update': ['SUPER_ADMIN', 'TENANT_ADMIN'],
  'billing:read': ['SUPER_ADMIN', 'TENANT_ADMIN'],
  'billing:manage': ['SUPER_ADMIN', 'TENANT_ADMIN'],
}

export function hasPermission(
  role: string | undefined,
  permission: Permission,
  explicitPermissions?: string[] | null
): boolean {
  if (explicitPermissions?.includes(permission)) return true
  const r = normalizeRole(role || 'VIEWER')
  if (r === 'SUPER_ADMIN') return true
  return (MATRIX[permission] || []).includes(r)
}

export function canImportExport(
  role: string | undefined,
  explicitPermissions?: string[] | null,
  tenantAllowsAdvanced: boolean = true
): boolean {
  if (!tenantAllowsAdvanced) return false
  return (
    hasPermission(role, 'import:execute', explicitPermissions) ||
    hasPermission(role, 'export:execute', explicitPermissions)
  )
}
